export const MENU_ICON_ARIA_LABEL = 'Display actions menu';
